import Image from 'next/image'
import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconPrescription } from '@redteclab/icons'

import illustrationDoctorOnline from './illustration-doctor-online.png'

const odsModalSteps = [
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModal.process.step1"
    key="pdp.buyboxwithvariants.odsModal.process.step1"
  />,
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModal.process.step2"
    key="pdp.buyboxwithvariants.odsModal.process.step2"
  />,
  <FormattedMessage
    id="pdp.buyboxwithvariants.odsModal.process.step3"
    key="pdp.buyboxwithvariants.odsModal.process.step3"
  />,
]

const paragraph = (chunks: ReactNode[]): JSX.Element => (
  <p className="mb-3">{chunks}</p>
)

export const ProductPageOdsDialogOnlineDoctorTabsPanel: FC = () => {
  const intl = useIntl()

  return (
    <section id="online-doctor">
      <Image
        alt={intl.formatMessage({
          id: 'pdp.buyboxwithvariants.odsModal.onlineConsultation.image.alt',
        })}
        className="mx-auto mb-5 shrink-0"
        height={96}
        src={illustrationDoctorOnline}
        unoptimized
        width={108}
      />
      <h2 className="mb-5 text-l">
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.heading" />
      </h2>
      <section id="ods-steps">
        <h3 className="font-medium">
          <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.stepsHeader" />
        </h3>
        <ol className="list-numbered-hexagon font-normal text-dark-primary-strong">
          {odsModalSteps.map((step, index) => (
            // eslint-disable-next-line react/no-array-index-key -- since the list is not changing, we can use the index as key
            <li className="mt-5" key={index}>
              {step}
            </li>
          ))}
        </ol>
      </section>
      <section className="mt-5" id="online-doctor-notice">
        <h3 className="mb-5 font-medium">
          <FormattedMessage id="general.modal.title.important" />
        </h3>
        <div className="text-dark-primary-strong">
          <FormattedMessage
            id="pdp.buyboxwithvariants.odsModal.tabs.tab1.onlineDoctorNotice"
            values={{
              paragraph,
            }}
          />
        </div>
      </section>
      <section className="mt-5" id="online-doctor-billing">
        <div className="flex">
          <div className="mr-2">
            <IconPrescription className="text-l" />
          </div>
          <div>
            <h3 className="mb-5 font-medium">
              <FormattedMessage id="pdp.buyboxwithvariants.odsModal.onlineDoctor.billingAsPrivate.heading" />
            </h3>
            <div className="text-dark-primary-strong">
              <FormattedMessage
                id="pdp.buyboxwithvariants.odsModal.onlineDoctor.billingAsPrivate.description"
                values={{
                  paragraph,
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}
